import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { Prices } from "../../../../components/modules/LineItems/components/Prices.js";
const PricesContainer = ({
  className,
  discount,
  orientation,
  originalPrice,
  totalPrice
}) => {
  const { currency, getLabel } = useIntl();
  const labels = {
    freeProduct: getLabel("products.freeProduct")
  };
  return /* @__PURE__ */ React.createElement(
    Prices,
    {
      className,
      currency,
      discount,
      orientation,
      originalPrice,
      totalPrice,
      labels
    }
  );
};
export {
  PricesContainer,
  PricesContainer as default
};
//# sourceMappingURL=PricesContainer.js.map
